module.exports = __webpack_public_path__ + "img/Weapon_axe_01_mesh.4c5757cc.png";